import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { useContactStore } from "./stores/contactStore";
import { useLegalStore } from "./stores/legalStore";
import "../src/assets/css/Styles.css";
import Header, {
  NavigationbarWithDropdownMultilevelMenu,
} from "./components/Header";
import Home from "./pages/homepage/Home";
import Footer from "./components/Footer";
import Advisory from "./pages/advisory/Advisory";
import BillingAddressGstNo from "./pages/advisory/BillingAddressGstNo";
import ChoosePaymentMode from "./pages/advisory/ChoosePaymentMode";
import ReadyReference from "./pages/readyreference/ReadyReference";
import Books from "./pages/books/Books";
import BooksBillingAddressGSTNo from "./pages/books/BooksBillingAddressGSTNo";
import BooksPayment from "./pages/books/BooksPayment";
import BooksDetails from "./pages/books/BooksDetails";
import TaxReturn from "./pages/taxreturn/TaxReturn";
import Training from "./pages/training/Training";
import TrainingDetails from "./pages/training/TrainingDetails";
import Webinar from "./pages/webinar/Webinar";
import WebinarDetails from "./pages/webinar/WebinarDetails";
import Article from "./pages/article/Article";
import ViewArticle from "./pages/article/ViewArticle";
import ArticleFormat from "./pages/article/ArticleFormat";
import QueriesDetails from "./pages/queries/QueriesDetails";
import LatestUpdate from "./pages/latestupdate/LatestUpdate";
import ImportantLinks from "./pages/importantlinks/ImportantLinks";
import Download from "./pages/download/Download";
import Practice from "./pages/practice/Practice";
import ScrollToTop from "./components/ScrollToTop";

//////////////////// Static ///////////////////////

import ArticleTwo from "./pagestwo/article/ArticleTwo";
import ArticleFormatTwo from "./pagestwo/article/ArticleFormatTwo";
import QueriesDetailsTwo from "./pagestwo/queries/QueriesDetailsTwo";
import ViewArticleTwo from "./pagestwo/article/ViewArticleTwo";
import LatestUpdateTwo from "./pagestwo/latestupdate/LatestUpdateTwo";
import NewsAlerts from "./pages/homepage/NewsAlerts";
import PaymentStatus from "./pages/payment/PaymentStatus";
import WebinarTwo from "./pagestwo/webinar/WebinarTwo";
import WebinarDetailsTwo from "./pagestwo/webinar/WebinarDetailsTwo";
import ReadyReferenceTwo from "./pagestwo/readyreference/ReadyReferenceTwo";
import BillingAddressReadyReferenceTwo from "./pagestwo/readyreference/BillingAddressReadyReferenceTwo";
import BooksDetailsTwo from "./pagestwo/books/BooksDetailsTwo";
import BooksViewCartTwo from "./pagestwo/books/BooksViewCartTwo";
import BooksCartBillingTwo from "./pagestwo/books/BooksCartBillingTwo";
import BooksSingleBillingTwo from "./pagestwo/books/BooksSingleBillingTwo";
import BooksSinglePaymentTwo from "./pagestwo/books/BooksSinglePaymentTwo";
import BooksCartPaymentTwo from "./pagestwo/books/BooksCartPaymentTwo";
import TrainingTwo from "./pagestwo/training/TrainingTwo";
import TrainingBillingAddressTwo from "./pagestwo/training/TrainingBillingAddressTwo";
import TrainingPaymentTwo from "./pagestwo/training/TrainingPaymentTwo";
import TrainingDetailsTwo from "./pagestwo/training/TrainingDetailsTwo";
import BooksTwo from "./pagestwo/books/BooksTwo";

////////////////////////////////////////////////////
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import EndUserLicenseAgreement from "./pages/legal/EndUserLicenseAgreement";
import DisclaimerCopyrights from "./pages/legal/DisclaimerCopyrights";
import PaymentTerms from "./pages/legal/PaymentTerms";
import CancellationReturnRefundPolicy from "./pages/legal/CancellationReturnRefundPolicy";
import LegalDetail from "./pages/legal/LegalDetail";
import AboutUs from "./pages/legal/AboutUs";
import Support from "./pages/support/Support";
import Location from "./pages/support/Location";
import BillingAddressReadyReference from "./pages/readyreference/BillingAddressReadyReference";
import ChoosePaymentReadyReference from "./pages/readyreference/ChoosePaymentReadyReference";
import BooksViewCart from "./pages/books/BooksViewCart";
import BooksCartBilling from "./pages/books/BooksCartBilling";
import BooksCartPayment from "./pages/books/BooksCartPayment";
import ChoosePaymentReadyReferenceTwo from "./pagestwo/readyreference/ChoosePaymentReadyReference";
import PracticeTwo from "./pagestwo/practice/PracticeTwo";
import BooksSingleBilling from "./pages/books/BooksSingleBilling";
import BooksSinglePayment from "./pages/books/BooksSinglePayment";
import TrainingBillingAddress from "./pages/training/TrainingBillingAddress";
import TrainingPayment from "./pages/training/TrainingPayment";
import TaxReturns from "./pages/taxreturns/TaxReturns";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import EmailOtpVerify from "./pages/auth/EmailOtpVerify";
import RegisterConfirm from "./pages/auth/RegisterConfirm";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ForgotConfirm from "./pages/auth/ForgotConfirm";
import ResetPassword from "./pages/auth/ResetPassword";
import PersonalInformation from "./pages/profile/PersonalInformation";
import Address from "./pages/profile/Address";
import TaxIdentificationNumber from "./pages/profile/TaxIdentificationNumber";
import ChangePassword from "./pages/profile/ChangePassword";
import ManageInterest from "./pages/profile/ManageInterest";
import MyAccount from "./pages/profile/MyAccount";
import MySubscription from "./pages/mysubscription/MySubscription";
import MyOrder from "./pages/myorder/MyOrder";
import MyOrderDetails from "./pages/myorder/MyOrderDetails";
import { HelmetProvider } from "react-helmet-async";
import MyLibrary from "./pages/mylibrary/MyLibrary";
import MyLibraryDetail from "./pages/mylibrary/MyLibraryDetail";
import MyLibraryPractice from "./pages/mylibrary/MyLibraryPractice";
import ReferAndEarn from "./pages/referandearn/ReferAndEarn";
import ManageNewsLetter from "./pages/managenewsletter/ManageNewsLetter";
import Product from "./pages/product/Product";
import PracticeArticle from "./pages/practice/PracticeArticle";
import PracticeArticleDetails from "./pages/practice/PracticeArticleDetails";
import BillingAddressPractice from "./pages/practice/BillingAddressPractice";
import ChoosePaymentPractice from "./pages/practice/ChoosePaymentPractice";
import { getEncodedCookie } from "./helpers/Reusable";
import { getCookie } from "./helpers/CookieComponent";
import OtpVerify from "./pages/auth/OtpVerify";
import MyLibraryPracticeDetails from "./pages/mylibrary/MyLibraryPracticeDetails";
import Sitemap from "./pages/sitemap/Sitemap";
function App() {
  window.addEventListener("beforeinstallprompt", function (e) {
    e.preventDefault();
    return false;
  });
  const auth = getCookie("token") || "";

  const fetchContactList = useContactStore((s) => s.fetchContactList);
  const fetchLegalList = useLegalStore((s) => s.fetchLegalList);
  useEffect(() => {
    fetchContactList();
    fetchLegalList();
  }, [fetchContactList, fetchLegalList]);

  console.log = console.warn = console.error = () => {};

  return (
    <>
      <NewsAlerts />
      <BrowserRouter basename={process.env.REACT_APP_BASE_URL}>
        {/* <Header /> */}
        <NavigationbarWithDropdownMultilevelMenu />
        <ScrollToTop />
        <Routes>
          <Route path="*" element={<Navigate to="/home" />} />
          <Route path="/home" element={<Home />}></Route>

          {/**************** Login ****************/}
          {!auth ? (
            <>
              <Route path="/login" element={<Login />}></Route>
              <Route path="/register" element={<Register />}></Route>
              <Route path="/otpverify" element={<EmailOtpVerify />}></Route>
              <Route
                path="/registerconfirm"
                element={<RegisterConfirm />}
              ></Route>
              <Route
                path="/forgotpassword"
                element={<ForgotPassword />}
              ></Route>
              <Route path="/forgotconfirm" element={<ForgotConfirm />}></Route>
              <Route path="/resetpassword" element={<ResetPassword />}></Route>
              <Route path="/mobileotpverify" element={<OtpVerify />}></Route>
            </>
          ) : (
            <>
              {/**************** Profile ****************/}
              <Route path="/myaccount" element={<MyAccount />}></Route>
              <Route
                path="/personalinfo"
                element={<PersonalInformation />}
              ></Route>
              <Route path="/myaddress" element={<Address />}></Route>
              <Route
                path="/mytaxidentification"
                element={<TaxIdentificationNumber />}
              ></Route>
              <Route
                path="/changepassword"
                element={<ChangePassword />}
              ></Route>
              <Route
                path="/manageinterest"
                element={<ManageInterest />}
              ></Route>

              <Route
                path="/mysubscription"
                element={<MySubscription />}
              ></Route>
              <Route path="/myorder" element={<MyOrder />}></Route>
              <Route path="/myorderdetail" element={<MyOrderDetails />}></Route>

              <Route path="/mylibrary" element={<MyLibrary />}></Route>
              <Route
                path="/mylibrarydetail"
                element={<MyLibraryDetail />}
              ></Route>
              <Route
                path="/mylibrary/practice"
                element={<MyLibraryPractice />}
              ></Route>
              <Route
                path="/mylibrary/practicedetails"
                element={<MyLibraryPracticeDetails />}
              ></Route>

              <Route path="/referandearn" element={<ReferAndEarn />}></Route>
              <Route
                path="/managenewsletter"
                element={<ManageNewsLetter />}
              ></Route>
            </>
          )}

          {/*************************** Knowledge Base  ***************************/}
          {/* Article */}
          <Route path="/article" element={<Article />}></Route>
          <Route path="/articlelist" element={<ArticleFormat />}></Route>

          <Route
            path="/viewarticle"
            element={
              <HelmetProvider>
                <ViewArticle />
              </HelmetProvider>
            }
          ></Route>

          <Route path="/queriesdetails" element={<QueriesDetails />}></Route>

          {/* Latest Update */}
          <Route path="/latestupdate" element={<LatestUpdate />}></Route>

          {/* Important Links */}
          <Route path="/importantlinks" element={<ImportantLinks />}></Route>

          {/* Download */}
          <Route path="/download" element={<Download />}></Route>

          {/*************************** Product  ***************************/}
          {/* Advisory */}
          <Route path="/product" element={<Product />}></Route>
          <Route path="/advisory/" element={<Advisory />}></Route>
          <Route
            path="/advisory/billing"
            element={<BillingAddressGstNo />}
          ></Route>
          <Route
            path="/advisory/payment"
            element={<ChoosePaymentMode />}
          ></Route>

          <Route path="/paymentstatus" element={<PaymentStatus />}></Route>

          <Route path="/readyreference" element={<ReadyReference />}></Route>
          <Route
            path="/readyreference/billing"
            element={<BillingAddressReadyReference />}
          ></Route>
          <Route
            path="/readyreference/payment"
            element={<ChoosePaymentReadyReference />}
          ></Route>
          <Route path="/practice" element={<PracticeArticle />}></Route>
          {/* <Route
            path="/practicedetails"
            element={<PracticeArticleDetails />}
          ></Route> */}
          <Route
            path="/practice/billing"
            element={<BillingAddressPractice />}
          ></Route>
          <Route
            path="/practice/payment"
            element={<ChoosePaymentPractice />}
          ></Route>
          {/* <Route path="/practicearticle" element={<PracticeArticle />}></Route> */}

          {/* Books */}
          <Route path="/books/" element={<Books />}></Route>
          {/* <Route
            path="/books/billing"
            element={<BooksBillingAddressGSTNo />}
          ></Route> */}
          {/* <Route path="/books/payment" element={<BooksPayment />}></Route> */}
          <Route path="/booksdetails" element={<BooksDetails />}></Route>
          <Route path="/viewcart" element={<BooksViewCart />}></Route>
          <Route
            path="/books/cartbilling"
            element={<BooksCartBilling />}
          ></Route>
          <Route path="/books/billing" element={<BooksSingleBilling />}></Route>
          <Route path="/books/payment" element={<BooksSinglePayment />}></Route>
          <Route
            path="/books/cartpayment"
            element={<BooksCartPayment />}
          ></Route>

          {/* Tax & Returns */}
          <Route path="/taxreturns" element={<TaxReturns />}></Route>

          {/* Traning */}
          <Route path="/training" element={<Training />}></Route>
          <Route
            path="/training/billing"
            element={<TrainingBillingAddress />}
          ></Route>
          <Route path="/training/payment" element={<TrainingPayment />}></Route>
          <Route path="/trainingdetails" element={<TrainingDetails />}></Route>

          {/* Webinar */}
          <Route path="/webinar" element={<Webinar />}></Route>
          <Route path="/webinardetails" element={<WebinarDetails />}></Route>

          {/* Legal */}
          <Route path="/legal" element={<LegalDetail />}></Route>
          <Route path="/privacypolicy" element={<PrivacyPolicy />}></Route>
          <Route
            path="/enduserlicenseagreement"
            element={<EndUserLicenseAgreement />}
          ></Route>
          <Route
            path="/disclaimerandcopyrights"
            element={<DisclaimerCopyrights />}
          ></Route>
          <Route path="/paymentterms" element={<PaymentTerms />}></Route>
          <Route
            path="/cancellationreturnrefundpolicy"
            element={<CancellationReturnRefundPolicy />}
          ></Route>
          <Route path="/aboutus" element={<AboutUs />}></Route>

          {/* Support */}
          <Route path="/support" element={<Support />}></Route>
          <Route path="/location" element={<Location />}></Route>

          {/* Sitemap */}
          <Route path="/sitemap" element={<Sitemap />}></Route>

          {/*************************** Static Pages ***************************/}
          {/* <Route path="/article2" element={<ArticleTwo />}></Route>
          <Route path="/articlelist2" element={<ArticleFormatTwo />}></Route>
          <Route
            path="/viewarticle2"
            element={
              <HelmetProvider>
                <ViewArticleTwo />
              </HelmetProvider>
            }
          ></Route>
          <Route
            path="/queriesdetails2"
            element={<QueriesDetailsTwo />}
          ></Route>
          <Route path="/latestupdate2" element={<LatestUpdateTwo />}></Route>
          <Route path="/webinar2" element={<WebinarTwo />}></Route>
          <Route
            path="/webinardetails2"
            element={<WebinarDetailsTwo />}
          ></Route>
          <Route
            path="/readyreference2"
            element={<ReadyReferenceTwo />}
          ></Route>
          <Route
            path="/readyreference/billing2"
            element={<BillingAddressReadyReferenceTwo />}
          ></Route>
          <Route
            path="/readyreference/payment2"
            element={<ChoosePaymentReadyReferenceTwo />}
          ></Route>

          <Route path="/practice2" element={<PracticeTwo />}></Route> */}

          {/* Books */}
          {/* <Route path="/books2/" element={<BooksTwo />}></Route>
          <Route path="/booksdetails2" element={<BooksDetailsTwo />}></Route>
          <Route path="/viewcart2" element={<BooksViewCartTwo />}></Route>
          <Route
            path="/books2/cartbilling2"
            element={<BooksCartBillingTwo />}
          ></Route>
          <Route
            path="/books2/billing2"
            element={<BooksSingleBillingTwo />}
          ></Route>
          <Route
            path="/books2/payment2"
            element={<BooksSinglePaymentTwo />}
          ></Route>
          <Route
            path="/books2/cartpayment2"
            element={<BooksCartPaymentTwo />}
          ></Route> */}

          {/* Traning */}
          {/* <Route path="/training2" element={<TrainingTwo />}></Route>
          <Route
            path="/training2/billing2"
            element={<TrainingBillingAddressTwo />}
          ></Route>
          <Route
            path="/training2/payment2"
            element={<TrainingPaymentTwo />}
          ></Route>
          <Route
            path="/trainingdetails2"
            element={<TrainingDetailsTwo />}
          ></Route> */}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
